export default "__VITE_ASSET__C4ywU090__"